import { cream } from 'shared/styles/colors';

export const getHighlightColor = (color, baseColorSet, highlightColorSet) => {
  for (let i = 0; i < baseColorSet.length; i += 1) {
    if (baseColorSet[i] === color) {
      return highlightColorSet[i];
    }
  }

  // default highlight should never be reached
  return cream;
};
